import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AuthService } from '../../reducers/services/auth.service';
import { Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';

const resetPasswordUrl = '/api/auth/recovery/new-password';

@Injectable()
export class AuthInterceptorService implements HttpInterceptor {
  currentUser: any;
  constructor(private authservice: AuthService, private router: Router, @Inject(PLATFORM_ID) private platformId: Object) { }
  private excludedRoutes: string[] = [
    '/users/login',
    '/users/signup',
    '/users/forgot-password',
    'https://tripxl.com/blog/wp-json/tripxlblog/v1/general-blog',
  ];

  private isExcludedRoute(request: string): boolean {
    return this.excludedRoutes.some((excludedRoute) =>
      request.includes(excludedRoute)
    );
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (this.isExcludedRoute(req.url)) {
      return next.handle(req);
    }
    let token = '';
    if (isPlatformBrowser(this.platformId)) {
      token = localStorage.getItem('auth_token') || '';
    }

    req = req.clone({
      setHeaders: {
        'x-access-key':
          'dHJpcHhsUHJpdmF0ZUxpbWl0ZWQucHVibGljYXBpbWFya2V0cGxhY2U=',
      },
    });
    if (token) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`, 
        },
      });
    }

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        let errorMessage = 'An unknown error occurred!';
        switch (error.status) {
          case 400:
            errorMessage = error?.error?.message;
            break;
          case 401:
            errorMessage = 'Invalid Access!';
            this.authservice.logout(this.router.url);
            break;
          case 403:
            errorMessage = 'Invalid Access!';
            this.authservice.logout(this.router.url);
            break;
          case 404:
            errorMessage =
              error?.error?.message ||
              'Not found! The resource does not exist.';
            break;
          case 500:
            errorMessage = 'Internal Server Error. Please try again later.';
            break;
          case 504:
            errorMessage = 'Server timed out. Please try again later.';
            break;
          default:
            errorMessage = error?.error?.message;
        }
        return throwError(error);
      })
    );
  }
}
